import React, { useState } from 'react';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { getProductImageUrl } from 'src/utils/image';
import { useAppSelector } from 'src/utils/Hooks';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Link } from 'react-router-dom';
import { BeaconProImageFallback } from 'src/components/SvgIcons';
import { AppName } from 'sl-api-connector';
import { getAppName } from 'src/utils/app';

interface ProductCellProps {
  title: string;
  stacklineSku: string;
  customLink?: string | null;
  overRideAdditionalParams?: string;
}

/**
 * Shows a product image and title for use in a table
 */
const ProductCell = ({ stacklineSku, title, customLink = null, overRideAdditionalParams }: ProductCellProps) => {
  const { searchParams, additionalParams } = useAppSelector((state) => state.app.queryParams);
  const [error, setError] = useState(false);
  const appName = getAppName();

  // Atlas product URLs should include tab=scorecardV2&subtab=all if not already present
  const existingParams = `${searchParams}${overRideAdditionalParams ?? additionalParams}`;
  const hasTabParam = existingParams.includes('tab=');
  const atlasProductParams = appName === AppName.Atlas && !hasTabParam ? '&tab=scorecardV2&subtab=all' : '';

  const Image = () => {
    if (error) {
      return (
        <BeaconProImageFallback style={{ minWidth: '30px', maxWidth: '30px', maxHeight: '30px', objectFit: 'cover' }} />
      );
    }

    return (
      <img
        key={stacklineSku}
        style={{ minWidth: '30px', maxWidth: '30px', maxHeight: '30px', objectFit: 'cover' }}
        src={getProductImageUrl(stacklineSku)}
        alt={title}
        onError={() => setError(true)}
      />
    );
  };

  return (
    <Flex gap="md" alignItems="center">
      <Image />
      <Link
        to={
          customLink ||
          `/product/${stacklineSku?.toUpperCase()}${searchParams}${overRideAdditionalParams ?? additionalParams}${atlasProductParams}`
        }
      >
        <Text variant="body2" truncateLines={2} title={title}>
          {title}
        </Text>
      </Link>
    </Flex>
  );
};

export default ProductCell;
